import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../core/environment.tokens";
import { SelectableInput } from "../../../dynamic-forms/inputs/selectable-input.model";

@Injectable({
  providedIn: "root",
})
export class StatesListService {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService
  ) { }

  getStateList(): Observable<SelectableInput[]> {
    const url = `${this.baseApiUrl}utility/stateslist`;
    return this.http.get(url).pipe(map(this.automapper.curryMany("States", "SelectableInput")));
  }
}
